import { PreguntaDTO } from "@DTOS";
import { Exporter } from "./Exporter";
import { ExporterMatriz, ExporterMultiple, ExporterNormal, ExporterText } from "./exporters";

export class ExporterRawData {
    public static exportar(respuestas: any, respuesta: any[], pregunta: PreguntaDTO): void {
        const it = this.obtenerListadoExporter().values();
        let posicionIt = it.next();

        let exporter: Exporter = posicionIt.value;

        while (!exporter.puedeExportar(pregunta) && !posicionIt.done) {
            posicionIt = it.next();
            exporter = posicionIt.value;
        }

        exporter.exportar(respuestas, respuesta, pregunta);
    }

    private static obtenerListadoExporter(): Exporter[] {
        return [new ExporterMatriz(), new ExporterText(), new ExporterMultiple(), new ExporterNormal()];
    }
}
